import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app-module';
import {hotModuleReplacement} from './shared/state/hot-store';
import {decorateModuleRef} from './shared/utils/ng-environment';
import {enableProdMode} from '@angular/core';

// enableProdMode(); // <!><!> Please investigate why this gives error.

require('./shared/assets/scss/main.scss');

function main() {
    return platformBrowserDynamic()
        .bootstrapModule( AppModule )
        .then(decorateModuleRef);
}

// Fresh load OR Hot load
if ((<any>module).hot) {
    hotModuleReplacement( main, module );
} else {
    platformBrowserDynamic()
        .bootstrapModule( AppModule )
        .then(decorateModuleRef);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/app-bootstrap.ts